export default __webpack_public_path__ + "static/article-thumbnail-0d4958fb7306e264b2903a36a856b7bc.webp";